define("js/scroll-to-top",["jquery","scrollTo"],function(t,o){"use strict";return function(e,n){t(n).click(function(e){e.preventDefault(),o(t("body").offset().top)})}});
